import React, { useState, useEffect } from 'react';
import axios from 'axios';
import useMediaQuery from '@mui/material/useMediaQuery';
import LoadingComponent from '../../components/LoadingComponent';

import { ThemeProvider, useTheme } from '@mui/material/styles';
import { TextField, Typography, Divider, Button, Grid, Box, Tabs, Tab, FormControlLabel } from '@mui/material';
import { DeliveryDiningOutlined, DownloadRounded, MonetizationOnOutlined, RoomServiceOutlined, SearchOutlined, TableBarOutlined, TrendingUpOutlined } from '@mui/icons-material';
import { createNewTheme, toReal } from '../../functions/utils';
import { Paper } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import Snackbar from '@mui/material/Snackbar';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '@fontsource/roboto/400.css';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs'; // Importação obrigatória
import 'dayjs/locale/pt-br';
import { PieChart } from '@mui/x-charts';
import { MaterialUISwitch } from '../../components/utils';

const roundLegend = {
  '& .MuiChartsLegend-mark': {
    rx: 6,
    ry: 6,
  },
}

const disableLinesAndTicks = {
  disableLine: true,
  disableTicks: true,
}

function Dashboard({ onChange, update, colorPrimary, colorSecondary, colorTertiary }, props) {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [aba, setAba] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [msgSnack, setMsgSnack] = useState(false);
  const [pedidosEntrega, setPedidosEntrega] = useState("0");
  const [pedidosMesa, setPedidosMesa] = useState("0");
  const [pedidosRetirada, setPedidosRetirada] = useState("0");
  const [totalPedidos, setTotalPedidos] = useState("0");
  const [faturamentoEntrega, setFaturamentoEntrega] = useState("0");
  const [faturamentoMesa, setFaturamentoMesa] = useState("0");
  const [faturamentoRetirada, setFaturamentoRetirada] = useState("0");
  const [totalFaturamento, setTotalFaturamento] = useState("0");
  const [dataFinal, setDataFinal] = React.useState(dayjs());
  const [dataInicial, setDataInicial] = React.useState(dayjs().subtract(7, 'day'));
  const [graficoEntrega, setGraficoEntrega] = useState();
  const [graficoMesa, setGraficoMesa] = useState();
  const [graficoRetirada, setGraficoRetirada] = useState();
  const [diasSemana, setDiasSemana] = useState();
  const [topProdutosQtd, setTopProdutosQtd] = React.useState([]);
  const [topProdutosValor, setTopProdutosValor] = React.useState([]);
  const [topCategorias, setTopCategorias] = React.useState([]);
  const [topPagamentos, setTopPagamentos] = React.useState([]);
  const [utilizaMeuHorario, setUtilizaMeuHorario] = useState(true);

  const handleOpenLoading = () => {
    setLoading(true);
  };

  const handleCloseLoading = () => {
    setLoading(false);
  };

  const handleSnack = (title) => {
    setMsgSnack(title);
    setOpenSnack(true);
    handleCloseLoading();
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  useEffect(() => {
    handleAtualizarDashboard();
    // getDashboard(dataInicial.startOf('day').unix(), dataFinal.startOf('day').unix());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [update]);

  const getDashboard = (dataInicial, dataFinal) => {
    const idestabelecimento = localStorage.getItem("Md");
    const urlbase = localStorage.getItem("UBs");
    axios.get(`${urlbase}/dash-pdv-v2.php?idestabelecimentos=${idestabelecimento}&datainicial=${dataInicial}&datafinal=${dataFinal}`)
      .then(response => {
        response = response.data
        console.log(response)
        if (!response) {
          handleSnack("Você não possui pedidos durante o período selecionado.")
          return
        }
        setFaturamentoEntrega(response.faturamentoEntrega)
        setFaturamentoMesa(response.faturamentoMesa)
        setFaturamentoRetirada(response.faturamentoRetirada)
        setTotalFaturamento(parseFloat(response.faturamentoEntrega) + parseFloat(response.faturamentoMesa) + parseFloat(response.faturamentoRetirada))
        setPedidosEntrega(response.pedidosEntrega)
        setPedidosMesa(response.pedidosMesa)
        setPedidosRetirada(response.pedidosRetirada)
        setTotalPedidos(parseInt(response.pedidosEntrega) + parseInt(response.pedidosMesa) + parseInt(response.pedidosRetirada))

        setGraficoEntrega([parseInt(response.entrega7), parseInt(response.entrega6), parseInt(response.entrega5), parseInt(response.entrega4), parseInt(response.entrega3), parseInt(response.entrega2), parseInt(response.entrega1)])
        setGraficoMesa([parseInt(response.mesa7), parseInt(response.mesa6), parseInt(response.mesa5), parseInt(response.mesa4), parseInt(response.mesa3), parseInt(response.mesa2), parseInt(response.mesa1)])
        setGraficoRetirada([parseInt(response.retirada7), parseInt(response.retirada6), parseInt(response.retirada5), parseInt(response.retirada4), parseInt(response.retirada3), parseInt(response.retirada2), parseInt(response.retirada1)])

        setDiasSemana([returnDia(response.diasemana7), returnDia(response.diasemana6), returnDia(response.diasemana5), returnDia(response.diasemana4), returnDia(response.diasemana3), returnDia(response.diasemana2), returnDia(response.diasemana1)])

        setTopProdutosQtd(response.topProdutosQtd || []);
        setTopProdutosValor(response.topProdutosValor || []);
        setTopCategorias(response.topCategorias || []);
        setTopPagamentos(response.topPagamentos || []);

        handleCloseLoading();
      })
      .catch(error => {
        handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente.")
      });
  };

  const returnDia = (dia) => {
    switch (dia) {
      case "1":
        return "Segunda";
      case "2":
        return "Terça";
      case "3":
        return "Quarta";
      case "4":
        return "Quinta";
      case "5":
        return "Sexta";
      case "6":
        return "Sabado";
      case "7":
        return "Domingo";
      default:
        return "";
    }
  }
  const handleAtualizarDashboard = () => {
    handleOpenLoading();

    const horariosestabelecimento = localStorage.getItem('hREst');

    let dataHoraDe = dataInicial.clone ? dataInicial.clone() : dataInicial;
    let dataHoraAte = dataFinal.clone ? dataFinal.clone() : dataFinal;

    if (utilizaMeuHorario && horariosestabelecimento) {
      const arrayHorarios = horariosestabelecimento.split(',');

      const getIndiceDia = (dataMoment) => {
        const diaJS = dataMoment.day();
        return diaJS === 0 ? 6 : diaJS - 1;
      };

      const strHorarioDe = arrayHorarios[getIndiceDia(dataHoraDe)];
      const strHorarioAte = arrayHorarios[getIndiceDia(dataHoraAte)];

      if (strHorarioDe && strHorarioDe !== 'Fechado' && strHorarioDe.includes('às')) {
        const horaInicial = strHorarioDe.split(' às ')[0].trim();
        const [hora, minuto] = horaInicial.split(':');
        dataHoraDe = dataHoraDe.hour(parseInt(hora)).minute(parseInt(minuto)).second(0).millisecond(0);
      }

      if (strHorarioAte && strHorarioAte !== 'Fechado' && strHorarioAte.includes('às')) {
        const horaFinal = strHorarioAte.split(' às ')[1].trim();
        const [hora, minuto] = horaFinal.split(':');
        dataHoraAte = dataHoraAte.hour(parseInt(hora)).minute(parseInt(minuto)).second(0).millisecond(0);
      }
    } else {
      dataHoraAte = dataHoraAte.hour(23).minute(59).second(59).millisecond(999);
    }

    if (dataHoraAte.hour() < dataHoraDe.hour()) {
      dataHoraAte = dataHoraAte.add(1, 'day')
    }

    getDashboard(dataHoraDe.unix(), dataHoraAte.unix())
  };

  const handleChangeAba = (event, newValue) => {
    setAba(newValue);
  };

  const handleVisualizarRelatorio = () => {

    const urlbase = localStorage.getItem("UBs");

    const horariosestabelecimento = localStorage.getItem('hREst');

    let dataHoraDe = dataInicial.clone ? dataInicial.clone() : dataInicial;
    let dataHoraAte = dataFinal.clone ? dataFinal.clone() : dataFinal;

    if (utilizaMeuHorario && horariosestabelecimento) {
      const arrayHorarios = horariosestabelecimento.split(',');

      const getIndiceDia = (dataMoment) => {
        const diaJS = dataMoment.day();
        return diaJS === 0 ? 6 : diaJS - 1;
      };

      const strHorarioDe = arrayHorarios[getIndiceDia(dataHoraDe)];
      const strHorarioAte = arrayHorarios[getIndiceDia(dataHoraAte)];

      if (strHorarioDe && strHorarioDe !== 'Fechado' && strHorarioDe.includes('às')) {
        const horaInicial = strHorarioDe.split(' às ')[0].trim();
        const [hora, minuto] = horaInicial.split(':');
        dataHoraDe = dataHoraDe.hour(parseInt(hora)).minute(parseInt(minuto)).second(0).millisecond(0);
      }

      if (strHorarioAte && strHorarioAte !== 'Fechado' && strHorarioAte.includes('às')) {
        const horaFinal = strHorarioAte.split(' às ')[1].trim();
        const [hora, minuto] = horaFinal.split(':');
        dataHoraAte = dataHoraAte.hour(parseInt(hora)).minute(parseInt(minuto)).second(0).millisecond(0);
      }
    } else {
      dataHoraAte = dataHoraAte.hour(23).minute(59).second(59).millisecond(999);
    }

    if (dataHoraAte.hour() < dataHoraDe.hour()) {
      dataHoraAte = dataHoraAte.add(1, 'day')
    }

    const url = `${urlbase}/relatorio-vendidos.php?datainicial=${dataHoraDe.unix()}&datafinal=${dataHoraAte.unix()}`;

    window.open(url, '_blank');
};

  const handleUtilizaMeuHorario = () => {
    setUtilizaMeuHorario(!utilizaMeuHorario)
    setTimeout(() => {
      handleAtualizarDashboard();
    }, 100);
  };

  return (
    <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>

      <div style={{ top: 75, bottom: 0, right: 0, left: isMobile ? 0 : 80, position: "absolute" }}>
        <Grid container spacing={2} style={{ padding: 16 }}>
          <Grid item xs={12}>
            <LoadingComponent open={loading} />

            <Snackbar
              open={openSnack}
              autoHideDuration={3000}
              onClose={handleClose}
              message={msgSnack}
              style={{ zIndex: "10001" }}
            />

            <Grid container alignItems="center" justifyContent="space-between" sx={{ mb: 3, mt: 1 }}>
              <Grid item xs={12} sm="auto">
                <Typography style={{ fontWeight: "bold", fontSize: '18px' }}>Análise de desempenho</Typography>
              </Grid>

              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={aba} onChange={handleChangeAba}>
                  <Tab label="Visão Geral" style={{ textTransform: "none", borderBottom: "1px solid #CCC" }} />
                  <Tab label="Performance de Vendas" style={{ textTransform: "none", borderBottom: "1px solid #CCC" }} />
                </Tabs>
              </Box>

              <Grid item xs={12} sm="auto" sx={{ mt: { xs: 2, sm: 2, md: 2, lg: 0 } }}>
                <div style={{ display: 'flex', alignItems: "center", justifyContent: "flex-end" }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                    <DatePicker
                      value={dataInicial}
                      onChange={(newValue) => setDataInicial(newValue)}
                      renderInput={(params) => <TextField {...params} />}
                      label="Data final do período"
                    />
                  </LocalizationProvider>
                  <Typography style={{ fontSize: 14, fontWeight: "bold", padding: "0px 10px" }}>Até</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                    <DatePicker
                      value={dataFinal}
                      onChange={(newValue) => setDataFinal(newValue)}
                      renderInput={(params) => <TextField {...params} />}
                      label="Data final do período"
                    />
                  </LocalizationProvider>
                  <Button disableElevation endIcon={<SearchOutlined />} variant="contained" size="large" style={{ height: "56px", fontWeight: "bold", textTransform: "capitalize", marginLeft: "10px", color: "#fff" }} onClick={handleAtualizarDashboard}>Buscar</Button>
                </div>
              </Grid>
            </Grid>

            {aba === 0 &&
              <>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                  {[
                    { label: 'Pedidos entrega', value: pedidosEntrega, color: "#0284c7", icon: <DeliveryDiningOutlined /> },
                    { label: 'Pedidos mesa', value: pedidosMesa, color: "#84cc16", icon: <TableBarOutlined /> },
                    { label: 'Pedidos retirada', value: pedidosRetirada, color: "#9333ea", icon: <RoomServiceOutlined /> },
                    { label: 'Total de pedidos', value: totalPedidos, color: "#64748b", icon: <TrendingUpOutlined /> }
                  ].map((card, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      <Paper variant='outlined' style={{ padding: '20px', borderRadius: '8px' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Typography style={{ color: "white", textAlign: "center", paddingTop: "8px", background: card.color, height: 40, width: 40, borderRadius: "50%", marginRight: '15px' }}>{card.icon}</Typography>
                          <div>
                            <Typography style={{ color: "#64748b", fontWeight: "bold", fontSize: "16px" }}>{card.label}</Typography>
                            <Typography style={{ color: "#475569", fontWeight: "bold", fontSize: "32px", lineHeight: '1.2' }}>{card.value}</Typography>
                          </div>
                        </div>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>

                <div style={{ height: "5px" }}></div>
                <Divider />
                <div style={{ height: "20px" }}></div>

                <Grid container spacing={2} sx={{ mb: 4 }}>
                  {[
                    { label: 'Faturamento entrega', value: faturamentoEntrega, color: "#0284c7" },
                    { label: 'Faturamento mesa', value: faturamentoMesa, color: "#84cc16" },
                    { label: 'Faturamento retirada', value: faturamentoRetirada, color: "#9333ea" },
                    { label: 'Total do faturamento', value: totalFaturamento, color: "#64748b" }
                  ].map((card, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      <Paper variant='outlined' style={{ padding: '20px', borderRadius: '8px' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Typography style={{ color: "white", textAlign: "center", paddingTop: "8px", background: card.color, height: 40, width: 40, borderRadius: "50%", marginRight: '15px' }}><MonetizationOnOutlined style={{ padding: 0 }} /></Typography>
                          <div>
                            <Typography style={{ color: "#64748b", fontWeight: "bold", fontSize: "16px" }}>{card.label}</Typography>
                            <Typography style={{ color: "#475569", fontWeight: "bold", fontSize: "32px", lineHeight: '1.2' }}><strong style={{ fontSize: "12px" }}>R$</strong>{toReal(card.value)}</Typography>
                          </div>
                        </div>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>

                {graficoEntrega && graficoMesa && graficoRetirada && (
                  <Grid container spacing={2}>

                    <Grid item xs={12} md={12}>
                      <Paper variant='outlined' style={{ padding: '20px', borderRadius: '8px' }}>
                        <Typography style={{ textAlign: "center", fontWeight: "bold", fontSize: "18px", mb: 2 }}>Gráfico de Vendas por Período (Tendência)</Typography>

                        <BarChart
                          sx={roundLegend}
                          slotProps={{
                            bar: {
                              clipPath: `inset(0px round 10px 10px 10px 10px)`,
                            },

                          }}
                          bottomAxis={disableLinesAndTicks}
                          leftAxis={disableLinesAndTicks}
                          xAxis={[{ scaleType: 'band', data: diasSemana }]}
                          series={[
                            { data: graficoEntrega, area: true, label: 'Pedidos entrega', color: '#0284c7' },
                            { data: graficoMesa, area: true, label: 'Pedidos mesa', color: '#84cc16' },
                            { data: graficoRetirada, area: true, label: 'Pedidos retirada', color: '#9333ea' },
                          ]}
                          height={400}
                          margin={{ left: 50, right: 30, top: 50, bottom: 40 }}
                        />
                      </Paper>
                    </Grid>

                  </Grid>
                )}
              </>
            }

            {aba === 1 && (
              <Grid container spacing={2} sx={{ mt: 1 }}>

                {/* --- BLOCO 1: TOP 10 PRODUTOS (QUANTIDADE) --- */}
                <Grid item xs={12} md={6}>
                  <Paper variant='outlined' style={{ padding: '20px', borderRadius: '8px', height: '100%' }}>
                    <Typography style={{ fontWeight: "bold", fontSize: "16px", color: "#64748b", mb: 2 }}>
                      Top 10 Produtos Mais Vendidos (Qtd)
                    </Typography>
                    {topProdutosQtd.length > 0 ? (
                      <BarChart
                        sx={roundLegend}
                        layout="horizontal"
                        slotProps={{
                          bar: {
                            clipPath: `inset(0px round 10px 10px 10px 10px)`,
                          },

                        }}
                        bottomAxis={disableLinesAndTicks}
                        leftAxis={disableLinesAndTicks}
                        yAxis={[{ scaleType: 'band', data: topProdutosQtd.map(p => p.nome.length > 17 ? `${p.nome.substring(0, 17)}...` : p.nome) }]}
                        series={[{ data: topProdutosQtd.map(p => p.valor), color: '#0284c7', label: 'Unidades' }]}
                        height={300}
                        margin={{ left: 140, right: 30, top: 40, bottom: 20 }}
                      />
                    ) : (
                      <Typography style={{ textAlign: "center", color: "#999", marginTop: "100px" }}>Sem dados no período</Typography>
                    )}
                  </Paper>
                </Grid>


                <Grid item xs={12} md={6}>
                  <Paper variant='outlined' style={{ padding: '20px', borderRadius: '8px', height: '100%' }}>
                    <Typography style={{ fontWeight: "bold", fontSize: "16px", color: "#64748b", mb: 2 }}>
                      Top 10 Produtos (Maior Faturamento R$)
                    </Typography>
                    {topProdutosValor.length > 0 ? (
                      <BarChart
                        sx={roundLegend}
                        layout="horizontal"
                        slotProps={{
                          bar: {
                            clipPath: `inset(0px round 10px 10px 10px 10px)`,
                          },

                        }}
                        bottomAxis={disableLinesAndTicks}
                        leftAxis={disableLinesAndTicks}
                        yAxis={[{ scaleType: 'band', data: topProdutosValor.map(p => p.nome.length > 17 ? `${p.nome.substring(0, 17)}...` : p.nome) }]}
                        series={[{
                          data: topProdutosValor.map(p => p.valor),
                          color: '#84cc16',
                          label: 'Faturamento (R$)',
                          valueFormatter: (value) => `R$ ${toReal(value)}`
                        }]}
                        height={300}
                        margin={{ left: 140, right: 30, top: 40, bottom: 20 }}
                      />
                    ) : (
                      <Typography style={{ textAlign: "center", color: "#999", marginTop: "100px" }}>Sem dados no período</Typography>
                    )}
                  </Paper>
                </Grid>

                {/* --- BLOCO 3: MIX DE CATEGORIAS (DONUT) --- */}
                <Grid item xs={12} md={6}>
                  <Paper variant='outlined' style={{ padding: '20px', borderRadius: '8px', height: '100%' }}>
                    <Typography style={{ fontWeight: "bold", fontSize: "16px", color: "#64748b", mb: 2 }}>
                      Mix de Categorias Mais Vendidas
                    </Typography>
                    {topCategorias.length > 0 ? (
                      <PieChart
                        sx={roundLegend}
                        series={[
                          {
                            data: topCategorias.map((c, index) => ({
                              id: index,
                              value: c.valor,
                              label: c.nome.length > 17 ? `${c.nome.substring(0, 17)}...` : c.nome
                            })),
                            innerRadius: 60,
                            paddingAngle: 3,
                            cornerRadius: 5,
                          }
                        ]}
                        height={280}
                        margin={{ right: 200, top: 20, bottom: 20, left: 10 }}

                        slotProps={{
                          legend: {
                            direction: 'column',
                            position: { vertical: 'middle', horizontal: 'right' },
                            itemMarkWidth: 12,
                            itemMarkHeight: 12,
                          }
                        }}
                      />
                    ) : (
                      <Typography style={{ textAlign: "center", color: "#999", marginTop: "100px" }}>Sem dados no período</Typography>
                    )}
                  </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Paper variant='outlined' style={{ padding: '20px', borderRadius: '8px', height: '100%' }}>
                    <Typography style={{ fontWeight: "bold", fontSize: "16px", color: "#64748b", mb: 2 }}>
                      Uso de Formas de Pagamento
                    </Typography>
                    {topPagamentos.length > 0 ? (
                      <PieChart
                        sx={roundLegend}
                        series={[
                          {
                            data: topPagamentos.map((p, index) => ({ id: index, value: p.valor, label: p.nome.length > 17 ? `${p.nome.substring(0, 17)}...` : p.nome })),
                            innerRadius: 60,
                            paddingAngle: 3,
                            cornerRadius: 5,
                          }
                        ]}
                        height={280}
                        margin={{ right: 180, top: 20, bottom: 20, left: 20 }}
                      />
                    ) : (
                      <Typography style={{ textAlign: "center", color: "#999", marginTop: "100px" }}>Sem dados no período</Typography>
                    )}
                  </Paper>
                </Grid>

                <Button disableElevation endIcon={<DownloadRounded />} variant="contained" size="large" sx={{ mt: 2, marginLeft: "auto", fontWeight: "bold", textTransform: "capitalize", color: "#fff" }} onClick={handleVisualizarRelatorio}>Visualizar Análise Completa</Button>

              </Grid>
            )}

            <div style={{ width: "100%", marginTop: 10 }}>
              <div style={{ background: "#F2F2F2", padding: 16, borderRadius: 8 }}>
                <Typography style={{ display: "flex", fontSize: 16, fontWeight: "600" }}>
                  <b>Utilizar seu horário de funcionamento?<br /><b style={{ fontSize: 12, fontWeight: "400" }}>Marque essa opção para obter o fechamento baseado no seu horário de funcionamento, caso não esteja marcado será utilizado das 00:00 até as 23:59</b></b>
                  <FormControlLabel style={{ marginLeft: "auto" }}
                    control={<MaterialUISwitch sx={{ m: 1 }} checked={utilizaMeuHorario} onChange={handleUtilizaMeuHorario} />}
                  />
                </Typography>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </ThemeProvider >
  );
}

export default Dashboard;